import {computed, defineComponent, getCurrentInstance, inject, Ref} from 'vue'

export default defineComponent({
    compatConfig: {
        MODE: 3
    },
    name: 'KlOlMapBaseLayerToggle',
    props: {
        tagName: {
            type: String,
            default: 'label'
        },
        title: {
            type: String,
            default: ''
        },
        image: {
            type: Object,
            default: null
        },
        active: Boolean
    },
    emits: ['_change'],
    setup() {
        const change: { handleChangeEvent: (event: any, value: string) => void } = inject('handleChangeEvent')
        const classes = computed(() => {
            return ['kl-ol-map-base-layer-toggle']
        })

        const emitSelect = ($event: any) => {
            change.handleChangeEvent($event, $event.target.value)
        }

        return {
            classes,
            emitSelect
        }
    }
})
